import styled from 'styled-components'

export const LogoImg = styled.img`
  width: 28px;
`
